import './pageHeaderRight.scss';
import React from 'react';
import { isEnterprise } from '../../utils/util';
import If from '../../common/components/if';
import { AppContext } from '../../context/appContext';
import { PlainText } from '../plainText/plainText';
import { useState, useContext, useEffect } from 'react';
import { getCurrent, getMsgCnt } from '../../common/utils/util';
import { LoginCard } from '../../components/loginCard/loginCard';
import { DropDown } from '../../common/components/dropDown/dropDown';
import { LoginState } from '../../components/loginState/loginState';
import { getUnReadCount } from '../../dataServices/msgCenterDataService';
import { getEnterpriseInfo } from '../../dataServices/getEnterpriseInfo';
import { EnterpriseCountdownNavItem } from '../../components/enterpriseCountdownNavItem/enterpriseCountdownNavItem';

import { VERSION_TYPE, IAccountPlan } from '../../interface/plan';

export interface IState {
    msgCnt: number;
    planId: number;
}

interface IProps {
    accountPlan: IAccountPlan;
}

export const PageHeaderRight = ({ accountPlan }: IProps) => {
    const appContext = useContext(AppContext);
    const {
        enterpriseInfo,
        isCAdministrator,
        msgCnt: incomeCnt = 0,
    } = appContext.state;
    const [msgCnt, setMsgCnt] = useState(0);
    const versionType = accountPlan.teacher_status;
    const enterpriseAccountType = Number(enterpriseInfo.role_type);
    const isEnterpriseAccount = isEnterprise(enterpriseInfo.enterprise_id);
    const [isDepartmentManager, setIsDepartmentManager] = useState(false);
    const isEnterpriseManage =
        isEnterpriseAccount && enterpriseAccountType >= 3;
    const isEnterpriseAdmin = isEnterpriseAccount && enterpriseAccountType >= 4;

    const getEnterprise = async () => {
        if (!isEnterpriseAccount) {
            return;
        }
        const res = await getEnterpriseInfo();
        if (!res.error_code && res.data) {
            setIsDepartmentManager(
                res.data.permission.is_department_manager === 1,
            );
        }
    };

    useEffect(() => {
        const load = () => {
            if (!incomeCnt) {
                getUnReadCount({}).then((ret) => {
                    if (ret.data && ret.data.total_num) {
                        setMsgCnt(ret.data.total_num);
                    }
                });
            }
            getEnterprise();
        };
        load();
    }, []);

    const cnt = getMsgCnt(incomeCnt || msgCnt);
    const isInstitute =
        versionType === VERSION_TYPE.INSTITUTE ||
        versionType === VERSION_TYPE.INSTITUTE_COMMON;
    const domain =
        (window as any)?.pageData?.config?.site_host || location.hostname;

    return (
        <div className="nav-header-right">
            <EnterpriseCountdownNavItem
                isAdmin={isEnterpriseAdmin}
                accountPlan={accountPlan}
            />
            <If
                condition={
                    isEnterpriseManage ||
                    isCAdministrator ||
                    isDepartmentManager
                }
            >
                <li className="page-header-nav-item to-platform-manage">
                    <a
                        href={`//${domain}/platformManage/index`}
                        className={
                            getCurrent('platformManage')
                                ? 'btn trackEvent current'
                                : 'btn trackEvent'
                        }
                    >
                        <If condition={!isInstitute}>
                            <PlainText>管理后台</PlainText>
                        </If>
                        <If condition={isInstitute}>
                            <PlainText>机构后台</PlainText>
                        </If>
                    </a>
                </li>
            </If>
            <li className="page-header-nav-item header-nav-msg">
                <a
                    className={
                        getCurrent('message')
                            ? 'btn trackEvent current'
                            : 'btn trackEvent'
                    }
                    href="/message"
                >
                    <If condition={!!cnt}>
                        <span className="msg-cnt">{cnt}</span>
                    </If>
                    <i className="icon icon-msg"></i>
                </a>
            </li>
            <DropDown content={<LoginState />}>
                <LoginCard />
            </DropDown>
        </div>
    );
};
